import { render } from "./InlineTable.vue?vue&type=template&id=6752ffc6&scoped=true"
const script = {}

import "./InlineTable.vue?vue&type=style&index=0&id=6752ffc6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6752ffc6"]])

export default __exports__